<template>
  <div>
    <Navbar />
    <div class="setting-main-wrapper">
      <div class="main-left-menu">
        <LeftMenu />
      </div>
      <Banner />
      <div class="shop-side bracket-play-wrapper p-md-0 pb-3">
        <BracketPlay />
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "../components/Header/Navbar.vue";
import LeftMenu from "../components/Home/LeftMenu.vue";
import Banner from "../components/BannerNotify/BannerPage.vue";
import BracketPlay from "../components/PoolPlayGenerator/BracketPlay.vue";

export default {
  data() {
    return {
    };
  },
  components: {
    Navbar,
    LeftMenu,
    Banner,
    BracketPlay
  }
};
</script>

<style scoped>
.bracket-play-wrapper {
  overflow: hidden;
}

@media screen and (max-width: 767.98px) {
  .bracket-play-wrapper {
    overflow-y: auto;
  }
}
</style>